export default __webpack_public_path__ + "static/media/delete.4663c0b5.jpg";